import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
// components
//
import { Spin } from "@arco-design/web-react";
import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";
import { otherRoutes } from "./other";

// ----------------------------------------------------------------------

export default function Router() {
    return (
        <Suspense
            fallback={
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "transparent"
                    }}
                >
                    <Spin dot  size={12}/>
                </div>
            }
        >
            {
                useRoutes([
                    // Auth routes
                    ...authRoutes,

                    // Dashboard routes
                    ...dashboardRoutes,

                    // // Other routes
                    ...otherRoutes
                ])
            }
        </Suspense>
    );
}
